import React, { useState } from "react";
import "./Hader.css";
import { Link } from "react-router-dom";
import ContactModal from "../pages/Contact us/Contact";


const Header = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          {/* Logo */}
          <Link className="navbar-brand" to="/">
            <img src="logo/logo.png" alt="Logo" className="logo" />
          </Link>

          {/* Toggler for mobile view */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <img src="/bannerimage/menu.png" alt="" style={{width:'24px'}}/>
          </button>

          {/* Navbar links and button */}
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/trackorder">
                  Track Order
                </Link>
              </li>
            </ul>

            {/* Button */}
            <button
              className="btn btn-primary"
              style={{ marginRight: "200px" }}
              onClick={handleShow}
            >
              Contact Us
            </button>
          </div>
        </div>
      </nav>
      {/* ContactModal Component */}
      <ContactModal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default Header;